export const POLICY_TYPES = {
   motorInsurance: "0101",
   homeInsurance: "0710",
   tranvelInsurance: "0204",
   domesticHelper: "0222",
   personalAccident: "0202",
   smartDevice: "0213",
   personalCyber: "0206",
   cyberSecurity: "0206",
   lifeInsurance: ["LTA-HDFC", "SVPRO", "LTAM", "ROFUTURE", "ROEDU", "REAYA", "FLEXSPL", "ROFUTPA"],
   aman: "0913",
   amanPlus: "0914"
}